<template>
  <div>
    <ul
      class="
        breadcrumb breadcrumb-transparent
        font-weight-bold
        p-0
        my-2
        font-size-sm
        mb-5
      "
    >
      <li class="breadcrumb-item">
        <img
          src="https://chart.googleapis.com/chart?chs=120x120&cht=qr&chl= dsdsdsddddddddddddddd&choe=UTF-8"
          width="60"
          title=""
        >
      </li>
      <li class="breadcrumb-item">
        <a
          href=" "
          class="text-muted"
        >{{ $t("site.welcome") }}</a>
      </li>
      <li class="breadcrumb-item">
        <a
          href="/"
          class="text-muted"
        >{{ $t("edu_programs.edu_programs") }}</a>
      </li>
      <li
        class="breadcrumb-item active"
        aria-current="page"
      >
        {{ eduProgram.name }}
      </li>
    </ul>

    <div class="main-program-title mb-6">
      <div class="row no-gutters align-items-center">
        <h1 class="font-size-h1 mr-4">
          {{ eduProgram.name }}
        </h1>
        <h4 class="font-size-h6 text-warning">
          <!-- {{ eduProgram.eduSeason.name }} -->
        </h4>
        <div class="mx-3 text-muted font-size-h3 opacity-40">
          |
        </div>

        <span
          v-if="room"
          id="roomId"
          class="btn btn-info btn-sm font-weight-bold btn-upper btn-text"
          :roomId="room.id"
        > {{ room.name }}</span>

        <h4
          v-else
          class="text-danger"
        >
          {{ $t('edu_programs.the_student_is_not_registered_in_any_class') }} !!
        </h4>

      </div>
    </div>

    <!-- icon slider -->

    <div class="mb-18 mt-10">
      <div
        id="top-program-carousel"
        class="carousel slide"
        data-ride="carousel"
      >
        <div class="carousel-inner px-10">
          <div class="carousel-item active">
            <div class="row">
              <div class="mb-4 mb-xl-0 col-sm-6 col-xl-3">
                <a
                  :href="'#/page/Courses/'+eduProgram.id"
                  class="ticket-btn px-5 h-100"
                >
                  <div class="title">
                    <h6>{{ $t("edu_programs.contents") }}</h6>
                    <h2>
                      {{ $t("edu_programs.and") }}
                      {{ $t("edu_programs.courses") }}
                    </h2>
                  </div>
                  <div class="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="42.551"
                      height="46.467"
                      viewBox="0 0 42.551 46.467"
                    >
                      <g
                        id="Group_13450"
                        data-name="Group 13450"
                        transform="translate(-11.449 -7.565)"
                      >
                        <path
                          id="Path_41980"
                          data-name="Path 41980"
                          d="M18.715,43.641H46.734A7.274,7.274,0,0,0,54,36.375V14.831a7.274,7.274,0,0,0-7.266-7.266H18.715a7.274,7.274,0,0,0-7.266,7.266V46.766a7.275,7.275,0,0,0,7.266,7.267H46.734A7.275,7.275,0,0,0,54,46.766v-5.4a8.852,8.852,0,0,1-4.142,3.255v2.145a3.127,3.127,0,0,1-3.124,3.124H18.715a3.125,3.125,0,1,1,0-6.249Zm-3.124-28.81a3.129,3.129,0,0,1,3.125-3.125H46.735a3.128,3.128,0,0,1,3.124,3.125V36.374A3.127,3.127,0,0,1,46.735,39.5H18.715a7.228,7.228,0,0,0-3.125.708V14.831Z"
                          transform="translate(0)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41981"
                          data-name="Path 41981"
                          d="M52,42.514c0-3.309-3.172-6.1-7.513-6.982v-1.1a9.023,9.023,0,0,0,3.026-6.422,5.958,5.958,0,1,0-11.915,0,9.023,9.023,0,0,0,3.027,6.422v1.1c-4.341.881-7.513,3.672-7.513,6.982v1.129H52Z"
                          transform="translate(-8.829 -6.505)"
                          fill="#fff"
                        />
                      </g>
                    </svg>
                  </div>
                </a>
              </div>
              <div class="mb-4 mb-xl-0 col-sm-6 col-xl-3">
                <a
                  href="#"
                  class="ticket-btn px-5 h-100"
                >
                  <div class="title">
                    <h6>{{ $t("edu_programs.details") }}</h6>
                    <h2>{{ $t("edu_programs.edu_program") }}</h2>
                  </div>
                  <div class="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="49.34"
                      height="53.8"
                      viewBox="0 0 49.34 53.8"
                    >
                      <g
                        id="noun_task_2145587_1_"
                        data-name="noun_task_2145587 (1)"
                        transform="translate(-8.757 -5)"
                      >
                        <path
                          id="Path_41982"
                          data-name="Path 41982"
                          d="M44.427,77.755,48.42,75.84a5.305,5.305,0,0,0,1.788-1.4L45.092,70.2a5.3,5.3,0,0,0-1.042,2.017L42.911,76.5a.3.3,0,0,0,.095.307l1.1.913A.3.3,0,0,0,44.427,77.755Z"
                          transform="translate(-13.733 -26.226)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41983"
                          data-name="Path 41983"
                          d="M80.924,27.668l5.114,4.237.235-.284a3.323,3.323,0,1,0-5.114-4.237Z"
                          transform="translate(-29.027 -8.478)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41984"
                          data-name="Path 41984"
                          d="M42.16,84.055l.413-.5-.8-.66-.413.5a.518.518,0,1,0,.8.66Z"
                          transform="translate(-13.062 -31.332)"
                          fill="#fff"
                        />
                        <rect
                          id="Rectangle_2984"
                          data-name="Rectangle 2984"
                          width="28.627"
                          height="6.644"
                          transform="matrix(0.638, -0.77, 0.77, 0.638, 32.496, 42.604)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41985"
                          data-name="Path 41985"
                          d="M21.472,47.957a1.793,1.793,0,1,0,1.793,1.793,1.793,1.793,0,0,0-1.793-1.793Z"
                          transform="translate(-4.393 -17.278)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41986"
                          data-name="Path 41986"
                          d="M31.872,48.961a1.2,1.2,0,1,0,0,2.391h12.96l1.728-2.086a1.2,1.2,0,0,0-.8-.3Z"
                          transform="translate(-8.816 -17.682)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41987"
                          data-name="Path 41987"
                          d="M21.472,34.277a1.793,1.793,0,1,0,1.793,1.793,1.793,1.793,0,0,0-1.793-1.793Z"
                          transform="translate(-4.393 -11.776)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41988"
                          data-name="Path 41988"
                          d="M46.955,36.473a1.2,1.2,0,0,0-1.2-1.2H31.874a1.2,1.2,0,1,0,0,2.391H45.76a1.2,1.2,0,0,0,1.2-1.2Z"
                          transform="translate(-8.817 -12.178)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41989"
                          data-name="Path 41989"
                          d="M21.472,61.637a1.793,1.793,0,1,0,1.793,1.793,1.793,1.793,0,0,0-1.793-1.793Z"
                          transform="translate(-4.393 -22.78)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41990"
                          data-name="Path 41990"
                          d="M40.037,62.641H31.872a1.2,1.2,0,1,0,0,2.391h6.187Z"
                          transform="translate(-8.816 -23.184)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41991"
                          data-name="Path 41991"
                          d="M21.472,75.316a1.793,1.793,0,1,0,1.793,1.793,1.793,1.793,0,0,0-1.793-1.793Z"
                          transform="translate(-4.393 -28.283)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41992"
                          data-name="Path 41992"
                          d="M31.029,76.667a1.2,1.2,0,0,0,.843,2.044h3.144a3.17,3.17,0,0,1,.09-.52l.5-1.871h-3.73A1.188,1.188,0,0,0,31.029,76.667Z"
                          transform="translate(-8.816 -28.687)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41993"
                          data-name="Path 41993"
                          d="M65.124,27.295V21.132a4.248,4.248,0,0,0-4.25-4.25H58.136a7.46,7.46,0,0,1,1.387,2.989h1.351a1.258,1.258,0,0,1,1.261,1.261V30.9Z"
                          transform="translate(-19.861 -4.779)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41994"
                          data-name="Path 41994"
                          d="M13.007,63.579H41.012a4.248,4.248,0,0,0,4.25-4.25V47.075l-2.989,3.6v8.65a1.261,1.261,0,0,1-1.261,1.261H13.007a1.261,1.261,0,0,1-1.261-1.261v-38.2a1.258,1.258,0,0,1,1.261-1.261h1.351a7.461,7.461,0,0,1,1.387-2.989H13.007a4.248,4.248,0,0,0-4.25,4.25v38.2a4.248,4.248,0,0,0,4.25,4.25Z"
                          transform="translate(0 -4.779)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41995"
                          data-name="Path 41995"
                          d="M42.513,16.846A4.931,4.931,0,0,0,39.54,12.3a3.13,3.13,0,0,1-1.778-2.566q-.007-.1-.019-.206a5.11,5.11,0,0,0-10.187.58,2.1,2.1,0,0,1-1.3,1.981,5.04,5.04,0,0,0-3.437,4.755,1.266,1.266,0,0,0,1.266,1.266H41.247a1.266,1.266,0,0,0,1.266-1.266ZM32.666,12.23a2.121,2.121,0,1,1,2.121-2.121A2.121,2.121,0,0,1,32.666,12.23Z"
                          transform="translate(-5.656 0)"
                          fill="#fff"
                        />
                      </g>
                    </svg>
                  </div>
                </a>
              </div>
              <div class="mb-4 mb-xl-0 col-sm-6 col-xl-3">
                <a
                  href="/"
                  class="ticket-btn px-5 h-100"
                >
                  <div class="title">
                    <h6>{{ $t("edu_programs.participants") }}</h6>
                    <h2>{{ $t("edu_programs.in_edu_program") }}</h2>
                  </div>
                  <div class="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="49.34"
                      height="53.8"
                      viewBox="0 0 49.34 53.8"
                    >
                      <g
                        id="noun_task_2145587_1_"
                        data-name="noun_task_2145587 (1)"
                        transform="translate(-8.757 -5)"
                      >
                        <path
                          id="Path_41982"
                          data-name="Path 41982"
                          d="M44.427,77.755,48.42,75.84a5.305,5.305,0,0,0,1.788-1.4L45.092,70.2a5.3,5.3,0,0,0-1.042,2.017L42.911,76.5a.3.3,0,0,0,.095.307l1.1.913A.3.3,0,0,0,44.427,77.755Z"
                          transform="translate(-13.733 -26.226)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41983"
                          data-name="Path 41983"
                          d="M80.924,27.668l5.114,4.237.235-.284a3.323,3.323,0,1,0-5.114-4.237Z"
                          transform="translate(-29.027 -8.478)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41984"
                          data-name="Path 41984"
                          d="M42.16,84.055l.413-.5-.8-.66-.413.5a.518.518,0,1,0,.8.66Z"
                          transform="translate(-13.062 -31.332)"
                          fill="#fff"
                        />
                        <rect
                          id="Rectangle_2984"
                          data-name="Rectangle 2984"
                          width="28.627"
                          height="6.644"
                          transform="matrix(0.638, -0.77, 0.77, 0.638, 32.496, 42.604)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41985"
                          data-name="Path 41985"
                          d="M21.472,47.957a1.793,1.793,0,1,0,1.793,1.793,1.793,1.793,0,0,0-1.793-1.793Z"
                          transform="translate(-4.393 -17.278)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41986"
                          data-name="Path 41986"
                          d="M31.872,48.961a1.2,1.2,0,1,0,0,2.391h12.96l1.728-2.086a1.2,1.2,0,0,0-.8-.3Z"
                          transform="translate(-8.816 -17.682)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41987"
                          data-name="Path 41987"
                          d="M21.472,34.277a1.793,1.793,0,1,0,1.793,1.793,1.793,1.793,0,0,0-1.793-1.793Z"
                          transform="translate(-4.393 -11.776)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41988"
                          data-name="Path 41988"
                          d="M46.955,36.473a1.2,1.2,0,0,0-1.2-1.2H31.874a1.2,1.2,0,1,0,0,2.391H45.76a1.2,1.2,0,0,0,1.2-1.2Z"
                          transform="translate(-8.817 -12.178)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41989"
                          data-name="Path 41989"
                          d="M21.472,61.637a1.793,1.793,0,1,0,1.793,1.793,1.793,1.793,0,0,0-1.793-1.793Z"
                          transform="translate(-4.393 -22.78)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41990"
                          data-name="Path 41990"
                          d="M40.037,62.641H31.872a1.2,1.2,0,1,0,0,2.391h6.187Z"
                          transform="translate(-8.816 -23.184)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41991"
                          data-name="Path 41991"
                          d="M21.472,75.316a1.793,1.793,0,1,0,1.793,1.793,1.793,1.793,0,0,0-1.793-1.793Z"
                          transform="translate(-4.393 -28.283)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41992"
                          data-name="Path 41992"
                          d="M31.029,76.667a1.2,1.2,0,0,0,.843,2.044h3.144a3.17,3.17,0,0,1,.09-.52l.5-1.871h-3.73A1.188,1.188,0,0,0,31.029,76.667Z"
                          transform="translate(-8.816 -28.687)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41993"
                          data-name="Path 41993"
                          d="M65.124,27.295V21.132a4.248,4.248,0,0,0-4.25-4.25H58.136a7.46,7.46,0,0,1,1.387,2.989h1.351a1.258,1.258,0,0,1,1.261,1.261V30.9Z"
                          transform="translate(-19.861 -4.779)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41994"
                          data-name="Path 41994"
                          d="M13.007,63.579H41.012a4.248,4.248,0,0,0,4.25-4.25V47.075l-2.989,3.6v8.65a1.261,1.261,0,0,1-1.261,1.261H13.007a1.261,1.261,0,0,1-1.261-1.261v-38.2a1.258,1.258,0,0,1,1.261-1.261h1.351a7.461,7.461,0,0,1,1.387-2.989H13.007a4.248,4.248,0,0,0-4.25,4.25v38.2a4.248,4.248,0,0,0,4.25,4.25Z"
                          transform="translate(0 -4.779)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41995"
                          data-name="Path 41995"
                          d="M42.513,16.846A4.931,4.931,0,0,0,39.54,12.3a3.13,3.13,0,0,1-1.778-2.566q-.007-.1-.019-.206a5.11,5.11,0,0,0-10.187.58,2.1,2.1,0,0,1-1.3,1.981,5.04,5.04,0,0,0-3.437,4.755,1.266,1.266,0,0,0,1.266,1.266H41.247a1.266,1.266,0,0,0,1.266-1.266ZM32.666,12.23a2.121,2.121,0,1,1,2.121-2.121A2.121,2.121,0,0,1,32.666,12.23Z"
                          transform="translate(-5.656 0)"
                          fill="#fff"
                        />
                      </g>
                    </svg>
                  </div>
                </a>
              </div>

              <div class="mb-4 mb-xl-0 col-sm-6 col-xl-3">
                <a
                  href="/"
                  class="ticket-btn px-5 h-100"
                >
                  <div class="title">
                    <h6>{{ $t("edu_programs.files") }}</h6>
                    <h2>{{ $t("edu_programs.??????") }}</h2>
                  </div>
                  <div class="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="45.615"
                      height="59.13"
                      viewBox="0 0 45.615 59.13"
                    >
                      <path
                        id="Path_41996"
                        data-name="Path 41996"
                        d="M26.6,42.8a1.3,1.3,0,1,1-1.3-1.3A1.3,1.3,0,0,1,26.6,42.8ZM25.3,35a1.3,1.3,0,1,0,1.3,1.3A1.3,1.3,0,0,0,25.3,35Zm16.894-6.5h-9.1a1.3,1.3,0,0,0,0,2.6h9.1a1.3,1.3,0,0,0,0-2.6ZM28.286,25,25.3,27.987l-.39-.39a1.287,1.287,0,0,0-1.819,1.819l1.3,1.3a1.256,1.256,0,0,0,1.819,0l3.9-3.9A1.287,1.287,0,0,0,28.286,25ZM60.515,49.235a1.356,1.356,0,0,1-.715,1.04l-4.354,2.144,3.119,6.173a1.275,1.275,0,0,1,.065.975,1.517,1.517,0,0,1-.65.78L51.873,63.4a1.9,1.9,0,0,1-.585.13,1.294,1.294,0,0,1-1.17-.715L47,56.643l-4.354,2.144a1.2,1.2,0,0,1-1.235-.065,1.277,1.277,0,0,1-.585-1.1V56.383H18.8a3.91,3.91,0,0,1-3.9-3.9V8.3a3.91,3.91,0,0,1,3.9-3.9H39.592a1.283,1.283,0,0,1,.91.39l11.7,11.7a1.283,1.283,0,0,1,.39.91V42.477L59.995,48A2.044,2.044,0,0,1,60.515,49.235ZM40.891,14.862a1.3,1.3,0,0,0,1.3,1.3h5.978L40.891,8.884ZM43.3,35.59l6.693,5.068V18.76h-7.8a3.91,3.91,0,0,1-3.9-3.9v-7.8H18.8a1.3,1.3,0,0,0-1.3,1.3V52.549a1.3,1.3,0,0,0,1.3,1.3H40.761V44.1H33.094a1.3,1.3,0,0,1,0-2.6h7.667V37.6H33.094a1.3,1.3,0,0,1,0-2.6h9.1A1.277,1.277,0,0,1,43.3,35.59Z"
                        transform="translate(-14.9 -4.4)"
                        fill="#fff"
                      />
                    </svg>
                  </div>
                </a>
              </div>
              <div class="mb-4 mb-xl-0 col-sm-6 col-xl-3">
                <a
                  href="/"
                  class="ticket-btn px-5 h-100"
                >
                  <div class="title">
                    <h6>{{ $t("edu_programs.questions") }}</h6>
                    <h2>{{ $t("edu_programs.and_answers") }}</h2>
                  </div>
                  <div class="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="45.615"
                      height="59.13"
                      viewBox="0 0 45.615 59.13"
                    >
                      <path
                        id="Path_41996"
                        data-name="Path 41996"
                        d="M26.6,42.8a1.3,1.3,0,1,1-1.3-1.3A1.3,1.3,0,0,1,26.6,42.8ZM25.3,35a1.3,1.3,0,1,0,1.3,1.3A1.3,1.3,0,0,0,25.3,35Zm16.894-6.5h-9.1a1.3,1.3,0,0,0,0,2.6h9.1a1.3,1.3,0,0,0,0-2.6ZM28.286,25,25.3,27.987l-.39-.39a1.287,1.287,0,0,0-1.819,1.819l1.3,1.3a1.256,1.256,0,0,0,1.819,0l3.9-3.9A1.287,1.287,0,0,0,28.286,25ZM60.515,49.235a1.356,1.356,0,0,1-.715,1.04l-4.354,2.144,3.119,6.173a1.275,1.275,0,0,1,.065.975,1.517,1.517,0,0,1-.65.78L51.873,63.4a1.9,1.9,0,0,1-.585.13,1.294,1.294,0,0,1-1.17-.715L47,56.643l-4.354,2.144a1.2,1.2,0,0,1-1.235-.065,1.277,1.277,0,0,1-.585-1.1V56.383H18.8a3.91,3.91,0,0,1-3.9-3.9V8.3a3.91,3.91,0,0,1,3.9-3.9H39.592a1.283,1.283,0,0,1,.91.39l11.7,11.7a1.283,1.283,0,0,1,.39.91V42.477L59.995,48A2.044,2.044,0,0,1,60.515,49.235ZM40.891,14.862a1.3,1.3,0,0,0,1.3,1.3h5.978L40.891,8.884ZM43.3,35.59l6.693,5.068V18.76h-7.8a3.91,3.91,0,0,1-3.9-3.9v-7.8H18.8a1.3,1.3,0,0,0-1.3,1.3V52.549a1.3,1.3,0,0,0,1.3,1.3H40.761V44.1H33.094a1.3,1.3,0,0,1,0-2.6h7.667V37.6H33.094a1.3,1.3,0,0,1,0-2.6h9.1A1.277,1.277,0,0,1,43.3,35.59Z"
                        transform="translate(-14.9 -4.4)"
                        fill="#fff"
                      />
                    </svg>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 mb-8 mb-lg-0 draggable-zone">
        <!-- البداية -->
        <div class="mb-4 draggable">
          <div
            id="kt_card_1"
            class="card card-custom py-2 px-4"
            data-card="true"
            style="border-top-left-radius: 35px"
          >
            <!-- card Header -->
            <div class="card-header p-0">
              <div class="row no-gutters w-100">
                <div class="col mr-2 d-flex align-items-center">
                  <div class="mr-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="26.42"
                      height="30.197"
                      viewBox="0 0 26.42 30.197"
                    >
                      <path
                        id="Icon_awesome-play"
                        data-name="Icon awesome-play"
                        d="M1.391,12.662,22.151.39a2.815,2.815,0,0,1,4.27,2.436v24.54a2.828,2.828,0,0,1-4.27,2.436L1.391,17.534a2.828,2.828,0,0,1,0-4.871Z"
                        transform="translate(0 -0.002)"
                        fill="#5f534c"
                      />
                    </svg>
                  </div>
                  <h2 class="blue-color font-size-h6">
                    {{ $t("edu_programs.starting_point") }}
                  </h2>
                </div>
                <div class="d-flex align-items-center">
                  <a
                    href="#"
                    class="btn btn-icon btn-sm btn-hover-light-danger"
                    data-card-tool="remove"
                  >
                    <i class="ki ki-close" />
                  </a>
                  <a
                    href="#"
                    class="
                      btn btn-icon btn-sm
                      opacity-50
                      hover-opacity-100
                      draggable-handle
                    "
                  >
                    <i class="fas fa-arrows-alt" />
                  </a>
                </div>
              </div>
            </div>
            <!-- end Card Header -->
            <div class="mt-5">
              <h3 class="text-dark font-size-h6 font-weight-bolder mb-3">
                {{ $t("edu_programs.edu_program_information") }}
              </h3>
              <div class="text-body line-height-lg font-size-lg">
                {{ eduProgram.explanation.substring(0,100) }}

              </div>
            </div>
            <div class="dash-todo p-0">
              <div class="item pb-5 mt-2">
                <!--begin::Bullet-->
                <!--end::Bullet-->
                <!--begin::Checkbox-->
                <label
                  class="
                    checkbox checkbox-babyblue checkbox-single
                    flex-shrink-0
                    m-0
                    mr-4
                  "
                >
                  <input
                    id="checkWelcome"
                    type="checkbox"
                    class="meta_field"
                    data-type="welcome"
                    disabled="disabled"
                    value="1"
                  >
                  <span />
                </label>
                <!--end::Checkbox-->
                <!--begin::Text-->
                <div class="d-flex flex-column flex-grow-1">
                  <a
                    href="#"
                    data-toggle="modal"
                    data-target="#welcome-message"
                  >
                    <span class="font-weight-bold">
                      <h2 class="brand-color title font-weight-bolder mt-1">
                        {{ $t("site.welcome_message") }}
                      </h2>
                    </span>
                  </a>
                </div>
                <!--end::Text-->
                <!--begin::Dropdown-->
                <div>
                  <input type="checkbox">
                </div>
                <!--end::Dropdown-->
              </div>

              <div class="item pb-5 mt-2">
                <!--begin::Bullet-->
                <!--end::Bullet-->
                <!--begin::Checkbox-->
                <label
                  class="
                    checkbox checkbox-babyblue checkbox-single
                    flex-shrink-0
                    m-0
                    mr-4
                  "
                >
                  <input
                    id="checkVideo"
                    type="checkbox"
                    class="meta_field"
                    data-type="video"
                    disabled="disabled"
                    value="1"
                  >
                  <span />
                </label>
                <!--end::Checkbox-->
                <!--begin::Text-->
                <div class="d-flex flex-column flex-grow-1">
                  <a
                    href="#"
                    data-toggle="modal"
                    data-target="#video-modal"
                  >
                    <span class="font-weight-bold">
                      <h2 class="brand-color title font-weight-bolder mt-1">
                        {{ $t("edu_programs.profile_video") }}
                      </h2>
                    </span>
                  </a>
                </div>
                <!--end::Text-->
                <!--begin::Dropdown-->
                <div>
                  <input type="checkbox">
                </div>
                <!--end::Dropdown-->
              </div>

              <div class="item pb-5 mt-2">
                <!--begin::Bullet-->
                <!--end::Bullet-->
                <!--begin::Checkbox-->
                <label
                  class="
                    checkbox checkbox-babyblue checkbox-single
                    flex-shrink-0
                    m-0
                    mr-4
                  "
                >
                  <input
                    id="checkAudio"
                    type="checkbox"
                    class="meta_field"
                    data-type="audio"
                    disabled="disabled"
                    value="1"
                  >
                  <span />
                </label>
                <!--end::Checkbox-->
                <!--begin::Text-->
                <div class="d-flex flex-column flex-grow-1">
                  <a
                    href="#"
                    data-toggle="modal"
                    data-target="#audio-modal"
                  >
                    <span class="font-weight-bold">
                      <h2 class="brand-color title font-weight-bolder mt-1">
                        {{ $t("edu_programs.profile_audio") }}
                      </h2>
                    </span>
                  </a>
                </div>
                <!--end::Text-->
                <!--begin::Dropdown-->
                <div>
                  <input type="checkbox">
                </div>
                <!--end::Dropdown-->
              </div>

              <div class="item pb-5 mt-2">
                <!--begin::Bullet-->
                <!--end::Bullet-->
                <!--begin::Checkbox-->
                <label
                  class="
                    checkbox checkbox-babyblue checkbox-single
                    flex-shrink-0
                    m-0
                    mr-4
                  "
                >
                  <input
                    id="checkPDF"
                    type="checkbox"
                    class="meta_field"
                    disabled="disabled"
                    data-type="pdf"
                    value="1"
                  >
                  <span />
                </label>
                <!--end::Checkbox-->
                <!--begin::Text-->
                <div class="d-flex flex-column flex-grow-1">
                  <a
                    href="#"
                    data-toggle="modal"
                    data-target="#file-modal"
                  >
                    <span class="font-weight-bold">
                      <h2 class="brand-color title font-weight-bolder mt-1">
                        {{ $t("edu_programs.profile_pdf_file") }}
                      </h2>
                    </span>
                  </a>
                </div>
                <!--end::Text-->
                <!--begin::Dropdown-->
                <div>
                  <input type="checkbox">
                </div>
                <!--end::Dropdown-->
              </div>
            </div>
          </div>
        </div>

        <!-- إجمالى الدرجات -->
        <div class="dash-banner draggable">
          <div class="draggable-handle position-relative">
            <div
              href="#"
              class="
                ml-4
                p-0
                m-0
                position-absolute
                right-0
                top-0
                zindex-2
                mr-4
                mt-2
              "
            >
              <i class="fas fa-arrows-alt" />
            </div>
          </div>
          <a
            href=""
            class="h-125px rounded-sm"
          >
            <div class="row no-gutters w-100 align-items-center">
              <div class="col d-flex">
                <div class="mr-3">
                  <div class="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="62.532"
                      viewBox="0 0 46.899 62.532"
                    >
                      <path
                        id="Icon_metro-bookmarks"
                        data-name="Icon metro-bookmarks"
                        d="M14.243,9.745V64.46L33.785,44.919,53.326,64.46V9.745ZM45.509,1.928H6.427V56.644l3.908-3.908V5.836H45.509Z"
                        transform="translate(-6.427 -1.928)"
                        fill="#fff"
                      />
                    </svg>
                  </div>
                </div>
                <div>
                  <h2>{{ $t("edu_programs.overall_grade") }}</h2>
                  <h6>{{ student_grades }}</h6>
                </div>
              </div>
              <div>
                <div
                  class="
                    px-5
                    py-2
                    text-center
                    border border-2 border-white
                    rounded-lg
                    opacity-90
                  "
                >
                  <h6 class="white-color">0</h6>
                  <p class="white-color">{{ $t("edu_programs.degree") }}</p>
                </div>
              </div>
            </div>
          </a>
        </div>

        <!-- مستخدمين أونلاين في الفصل -->
        <div
          id="kt_card_2"
          class="draggable"
          data-card="true"
        >
          <div class="title-ban-g card-header">
            <div class="border-0 bg-transparent p-0">
              <div class="row no-gutters w-100">
                <div class="col mr-2 d-flex align-items-center">
                  <div class="title-content">
                    <img
                      src="/assets/images/prog-ban-to.svg"
                      alt=""
                    >
                    <h2 class="title font-size-lg font-size-h6-xxl">
                      {{ $t("edu_programs.online_users_in_room") }}
                    </h2>
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <a
                    href="#"
                    class="btn btn-icon btn-sm btn-hover-light-danger"
                    data-card-tool="remove"
                  >
                    <i class="ki ki-close" />
                  </a>
                  <a
                    href="#"
                    class="
                      btn btn-icon btn-sm
                      opacity-50
                      hover-opacity-100
                      draggable-handle
                    "
                  >
                    <i class="fas fa-arrows-alt" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="dash-program-caro p-2 pb-5 rounded-bottom-xl mb-5">
            <div class="files-area">
              <div
                id="spinnerUser"
                class="text-center"
                style="display: none"
              >
                <div class="spinner-border text-warning" />
              </div>

              <div
                id="tableUser"
                class="table-responsive"
              >
                <ul id="onLine" />
              </div>
            </div>
          </div>
        </div>

        <!-- الدعم الفني -->

        <div class="mt-10 draggable">
          <div>
            <div
              class="
                row
                no-gutters
                mt-8
                justify-content-center
                align-items-center
                undertodolist
                mb-4
              "
            >
              <div class="col-12 text-center">
                <a
                  href="#"
                  class="p-0 m-0 opacity-50 hover-opacity-100 draggable-handle"
                >
                  <i class="fas fa-arrows-alt" />
                </a>
              </div>
              <div
                class="
                  col-12 col-sm-6
                  pl-sm-5 pl-lg-0
                  col-lg-12 col-xl
                  mb-5 mb-sm-0
                  mr-xl-2
                "
              >
                <a
                  href="http://support.omg.com.eg/login/?user= &pass= "
                  class="ticket-btn"
                >
                  <div class="title">
                    <h6>{{ $t("edu_programs.contact") }}</h6>
                    <h2>{{ $t("edu_programs.with_us") }}</h2>
                  </div>
                  <div class="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="79.96"
                      height="71.284"
                      viewBox="0 0 79.96 71.284"
                    >
                      <g
                        id="noun_contact_1549898"
                        transform="translate(-4 -8.982)"
                      >
                        <g
                          id="Group_13309"
                          data-name="Group 13309"
                          transform="translate(4 8.982)"
                        >
                          <path
                            id="Path_41950"
                            data-name="Path 41950"
                            d="M31.622,9a.869.869,0,0,0-.272.136L4.407,26.516A.869.869,0,0,0,4,27.249V62.015a.869.869,0,0,0,.869.869H45.8A19.115,19.115,0,0,0,76.057,76.627a.875.875,0,0,0-1.032-1.412,17.371,17.371,0,1,1,7.2-14.069,6,6,0,0,1-1.358,4.074A4.668,4.668,0,0,1,77.2,66.741a5.4,5.4,0,0,1-5.4-5.025V54.193a.869.869,0,1,0-1.738,0v1.983a6.547,6.547,0,0,0-5.3-2.852c-3.857,0-6.872,3.576-6.872,7.822s3.015,7.822,6.872,7.822a6.8,6.8,0,0,0,6.084-4.21A7.343,7.343,0,0,0,77.2,68.479a6.507,6.507,0,0,0,4.97-2.091,7.771,7.771,0,0,0,1.793-5.242A19.095,19.095,0,0,0,59.625,42.758V27.249a.869.869,0,0,0-.407-.733L32.274,9.134A.869.869,0,0,0,31.622,9Zm.19,1.874L57.153,27.222,31.812,43.6,6.472,27.222ZM5.738,28.825,31.351,45.338a.869.869,0,0,0,.923,0L57.886,28.825V43.356a19.113,19.113,0,0,0-12.168,17.79H5.738Zm59.02,26.237c2.767,0,5.133,2.65,5.133,6.084s-2.366,6.084-5.133,6.084-5.133-2.65-5.133-6.084S61.99,55.062,64.758,55.062Z"
                            transform="translate(-4 -8.982)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                </a>
              </div>
              <div class="col-12 col-sm-6 col-lg-12 col-xl mr-xl-2">
                <a
                  href="http://support.omg.com.eg/login/?user=&pass= "
                  class="ticket-btn"
                >
                  <div class="title">
                    <h6>{{ $t("edu_programs.add") }}</h6>
                    <h2>{{ $t("edu_programs.new_ticket") }}</h2>
                  </div>
                  <div class="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="34"
                      height="59.5"
                      viewBox="0 0 34 59.5"
                    >
                      <g
                        id="noun_Ticket_1785872"
                        transform="translate(42 -2) rotate(90)"
                      >
                        <path
                          id="Path_41951"
                          data-name="Path 41951"
                          d="M60.012,20.963A2.041,2.041,0,0,0,61.5,19.05V10.125A2.008,2.008,0,0,0,59.375,8H4.125A2.008,2.008,0,0,0,2,10.125V19.05a2.041,2.041,0,0,0,1.488,1.913,4.336,4.336,0,0,1,2.55,5.525,4.315,4.315,0,0,1-2.55,2.55A2.041,2.041,0,0,0,2,30.95v8.925A2.008,2.008,0,0,0,4.125,42h55.25A2.008,2.008,0,0,0,61.5,39.875V30.95a2.559,2.559,0,0,0-1.488-2.125,4.336,4.336,0,0,1-2.55-5.525,5.492,5.492,0,0,1,2.55-2.337Zm-2.762-3.4A8.652,8.652,0,0,0,54.063,29.25a9.151,9.151,0,0,0,3.188,3.188V37.75H21.125V36.688A2.008,2.008,0,0,0,19,34.563a2.008,2.008,0,0,0-2.125,2.125V37.75H6.25V32.438A8.652,8.652,0,0,0,9.438,20.75,9.151,9.151,0,0,0,6.25,17.563V12.25H16.875v3.188A2.008,2.008,0,0,0,19,17.563a2.008,2.008,0,0,0,2.125-2.125V12.25H57.25Z"
                          fill="#fff"
                        />
                        <path
                          id="Path_41952"
                          data-name="Path 41952"
                          d="M19.325,21.338,18.05,25.162a1.032,1.032,0,0,0,.637,1.275c.425.213.637,0,1.063-.213l3.4-2.337,3.4,2.337a1.05,1.05,0,0,0,1.487-.212,1.592,1.592,0,0,0,.213-1.062l-1.275-3.825,3.4-2.338a1.05,1.05,0,0,0,.213-1.487,1.1,1.1,0,0,0-.85-.425H25.7L24.425,13.05a1.321,1.321,0,0,0-1.275-.85c-.425,0-.638.425-.85.85l-1.275,3.825H16.563A1,1,0,0,0,15.5,17.938a1.1,1.1,0,0,0,.425.85Z"
                          transform="translate(15.188 4.725)"
                          fill="#fff"
                        />
                        <path
                          id="Path_41953"
                          data-name="Path 41953"
                          d="M11.125,13.8A2.008,2.008,0,0,0,9,15.925v7.012a2.008,2.008,0,0,0,2.125,2.125,2.008,2.008,0,0,0,2.125-2.125V15.925A2.129,2.129,0,0,0,11.125,13.8Z"
                          transform="translate(7.875 6.525)"
                          fill="#fff"
                        />
                      </g>
                    </svg>
                  </div>
                </a>
              </div>
              <div class="text-center mt-5 col-12">
                <h2 class="display-5">
                  {{ $t("edu_programs.available_tickets_number") }} 20
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-8 mt-12 mt-lg-0 draggable-zone">
        <announcement
          :items="announcement"
          :title="'alerts'"
        />
        <announcement
          :items="polls"
          :title="'polls'"
        />
        <current-events-vue />

        <!-- المسار التعليمي -->

        <div class="row" />
      </div>
    </div>
  </div>
</template>

<script>
import EduProgramsController from '../../../Controllers/EduProgramsController'
import Announcement from '../Home/components/Announcement.vue'
import CurrentEventsVue from '../Home/components/CurrentEvents.vue'

export default {
  components: {
    Announcement,
    CurrentEventsVue,
  },
  data() {
    return {
      eduProgram: {},
      announcement: [],
      polls: [],
      student_grades: '',
      room: '',
    }
  },
  async created() {
    console.log(this.$route.params)
    const data = await new EduProgramsController().Home(
      this.$route.params.eduProgramId,
    )
    this.eduProgram = data.eduProgram.eduProgram

    this.announcement = data.eduProgram.announcements
    this.polls = data.eduProgram.polls
    this.student_grades = data.eduProgram.student_grades
    this.room = data.eduProgram.room
  },
}
</script>

<style>
</style>
